package one.healthium.insights.ui.components.items

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import one.healthium.insights.domain.models.ColorModel
import one.healthium.insights.domain.models.ContentEntry
import one.healthium.insights.ui.utils.resolve
import one.healthium.ui.compose.theme.AppTheme
import one.healthium.ui.compose.theme.black15
import androidx.compose.ui.tooling.preview.Preview

@Composable
fun ContentLine(
    modifier: Modifier = Modifier,
    entry: ContentEntry.Line,
) {
    Box(
        modifier
            .padding(vertical = 24.dp)
            .padding(
                start = entry.indent?.dp ?: 0.dp,
                end = entry.endIndent?.dp ?: 0.dp,
            )
            .height(entry.thickness?.dp ?: 1.dp)
            .fillMaxWidth()
            .background(color = entry.color?.resolve() ?: black15)
    )
}

@Composable
@Preview(showBackground = true)
private fun LinePreview() {
    AppTheme {
        Column(
            verticalArrangement = Arrangement.spacedBy(8.dp),
        ) {
            ContentLine(
                entry = ContentEntry.Line(
                    thickness = 1,
                    color = ColorModel.Hex(0xFFE0E0E0),
                    indent = null,
                    endIndent = null,
                )
            )

            ContentLine(
                entry = ContentEntry.Line(
                    thickness = 1,
                    color = ColorModel.Hex(0xFFE0E0E0),
                    indent = 16,
                    endIndent = 24,
                )
            )
        }
    }
}